export function handleClickContactUs() {
  window.location.href = "mailto:sales@optimetriks.com";
}
